import { buildFunctionUrl, getJson } from "../../services/functionApi";

/** The teams the club runs. Every other view is scoped to one of them. */
export async function fetchTeamNames(accessToken: string | null): Promise<string[]> {
  const url = buildFunctionUrl("teams/list", "accounts");
  const result = await getJson<unknown>(url, accessToken, "accounts");

  return Array.isArray(result) ? (result as string[]) : [];
}
